import { mapDrawReducer, MapDrawState } from './map-draw.reducer';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

export interface AppState {
	mapDraw: MapDrawState;
}

export const reducers: ActionReducerMap<AppState> = {
	mapDraw: mapDrawReducer
};


export const selectMapDrawState = createFeatureSelector<MapDrawState>('mapDraw');

export const selectDrawnItems = createSelector(
	selectMapDrawState,
	(state: MapDrawState) => state.drawnItems
);

export const selectBounds = createSelector(
	selectMapDrawState,
	(state: MapDrawState) => state.bounds
);
